export default __webpack_public_path__ + "static/media/add_friend.4e96ec50.svg";